import { TextBoxItem } from "components/Input/TextBox";
import { STFilterField, STTableColumnDetail } from "../STTableProps";
import { SelectItem } from "components/Input/Select/SelectItem";
import { MultipleSelectItem } from "components/Input/Select/MultipleSelectItem";
import { DateRangePickerItem } from "components/Input/DatePicker/DateRangePickerItem";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import { I18n } from "utilities/utilities";

const ControlFilter = (
  item: STFilterField,
  colums: STTableColumnDetail[],
  isLoading,
  sTableID
) => {
  let sLabelFilter = item.sLabel;
  if (!item.sLabel) {
    const objColumns = colums.find((f) => f.field === item.sFieldName);
    if (objColumns) {
      sLabelFilter = objColumns.headerName;
    }
  }
  let sFieldName = item.fieldSearch ? item.fieldSearch : item.sFieldName;
  let sIDFilter = `filter_${sTableID}_${sFieldName}`;
  let arrOption = item.optionSelect ? item.optionSelect : [];

  switch (item.sTypeFilterMode) {
    case "input": {
      return (
        <TextBoxItem
          id={sIDFilter}
          label={sLabelFilter}
          name={sIDFilter}
          type={"text"}
          maxLength={200}
          required={false}
          style={{ margin: "0" }}
        />
      );
    }
    case "select": {
      return (
        <SelectItem
          required={false}
          label={sLabelFilter}
          id={sIDFilter}
          name={sIDFilter}
          options={arrOption}
        />
      );
    }
    case "multiselect": {
      return (
        <MultipleSelectItem
          required={false}
          label={sLabelFilter}
          id={sIDFilter}
          name={sIDFilter}
          options={arrOption}
          limitTag={1}
          IsPopperCustom={false}
        />
      );
    }
    case "daterange": {
      return (
        <DateRangePickerItem
          name={sIDFilter}
          id={sIDFilter}
          label={sLabelFilter}
          labelStart={`${item.sLabel} ${I18n.SetText("start")}`}
          labelEnd={`${item.sLabel} ${I18n.SetText("end")}`}
         
        />
      );
    }
    case "date": {
      return (
        <DatePickerItem
          name={sIDFilter}
          id={sIDFilter}
          label={sLabelFilter}
          fullWidth
        />
      );
    }
  }
};

export default ControlFilter;